// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"580":"48c68fb6","654":"dcc4907c","954":"f25d7f74"}[chunkId] + ".chunk.css";
};